import { render } from "./AdminFaq.vue?vue&type=template&id=13d98215&lang=true"
import script from "./AdminFaq.vue?vue&type=script&lang=js"
export * from "./AdminFaq.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__